<script setup lang="ts">
import { MessageContentPartTypes, useMessageContentLinks } from '@/entities/message/lib';

const { content } = defineProps<{ content: string }>();

const { parts } = useMessageContentLinks(() => content);
</script>

<template>
  <div class="word text-[15px] leading-snug wrap-anywhere whitespace-pre-wrap">
    <template
      v-for="(part, index) in parts"
      :key="`${part.type}-${part.value}-${index}`"
    >
      <a
        v-if="part.type === MessageContentPartTypes.LINK"
        :href="part.href"
        target="_blank"
        rel="noopener noreferrer"
        class="break-all text-inherit underline decoration-current underline-offset-2 transition hover:opacity-80"
        @click.stop
        >{{ part.value }}</a
      >

      <template v-else>{{ part.value }}</template>
    </template>
  </div>
</template>
